var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 0V21.3333H24V24H0V0H2.66667ZM23.0573 4.39067L24.9427 6.276L17.3333 13.8853L13.3333 9.88667L7.60933 15.6093L5.724 13.724L13.3333 6.11467L17.3333 10.1133L23.0573 4.39067Z",
    fill: "#8AAEF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyGraph);
export default __webpack_public_path__ + "static/media/dummy-graph.4a0bdaeb.svg";
export { ForwardRef as ReactComponent };